import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { HubService, User, UserService } from 'briteatlib';
import { SharedModule } from './modules/shared/shared.module';
import { SharedService } from './services/shared.service';
import { AppUpdateComponent } from 'projects/briteatlib/src';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, SharedModule, AppUpdateComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  providers: []
})
export class AppComponent {
  loading = false;
  business: any;
  env = environment.env;

  constructor(private userService: UserService, private sharedService: SharedService, private hubService: HubService, private titleService: Title) {
  }

  async ngOnInit() {
    this.business = await this.sharedService.setActiveBusiness();
    setTimeout(() => this.loading = false);
    if (this.business?.Id) {
      this.userService.current$.subscribe(async (user: User) => {
        if (user?.Id && this.business.Staffs?.some(_ => _.UserId === user.Id && _.Permissions?.includes('Order')))
          this.hubService.join(this.business.Id);
      });
      if (this.business.UI?.Title)
        this.titleService.setTitle(this.business.UI.Title);
    }
  }

  async ngOnDestroy() {
    if (this.business?.Id) this.hubService.leave(this.business.Id);
  }
}
